// extracted by mini-css-extract-plugin
export var desc = "style-module--desc--bf17d";
export var head = "style-module--head--70910";
export var img = "style-module--img--f07be";
export var info = "style-module--info--df0d0";
export var smi = "style-module--smi--37e35";
export var sub = "style-module--sub--657e8";
export var swiperBtnNext = "style-module--swiper-btn-next--0a789";
export var swiperBtnPrev = "style-module--swiper-btn-prev--13e96";
export var swiperButtons = "style-module--swiper-buttons--969c6";
export var wrap = "style-module--wrap--cbc6a";